// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"3ace55ba","769":"248691b8"}[chunkId] + ".chunk.css";
};